// Country picker list for the booking wizard.
// `code` = ISO 3166 alpha-2. Order matters (United States first, then the main
// Spanish-speaking markets, then Brazil + Canada). Active status is derived at
// runtime from the zones we actually serve.
export const COUNTRIES = [
  { code: "US", flag: "🇺🇸", name_en: "United States", name_es: "Estados Unidos" },
  { code: "AR", flag: "🇦🇷", name_en: "Argentina", name_es: "Argentina" },
  { code: "MX", flag: "🇲🇽", name_en: "Mexico", name_es: "México" },
  { code: "CO", flag: "🇨🇴", name_en: "Colombia", name_es: "Colombia" },
  { code: "CL", flag: "🇨🇱", name_en: "Chile", name_es: "Chile" },
  { code: "PE", flag: "🇵🇪", name_en: "Peru", name_es: "Perú" },
  { code: "ES", flag: "🇪🇸", name_en: "Spain", name_es: "España" },
  { code: "DO", flag: "🇩🇴", name_en: "Dominican Republic", name_es: "República Dominicana" },
  { code: "PR", flag: "🇵🇷", name_en: "Puerto Rico", name_es: "Puerto Rico" },
  { code: "CR", flag: "🇨🇷", name_en: "Costa Rica", name_es: "Costa Rica" },
  { code: "EC", flag: "🇪🇨", name_en: "Ecuador", name_es: "Ecuador" },
  { code: "VE", flag: "🇻🇪", name_en: "Venezuela", name_es: "Venezuela" },
  { code: "UY", flag: "🇺🇾", name_en: "Uruguay", name_es: "Uruguay" },
  { code: "PY", flag: "🇵🇾", name_en: "Paraguay", name_es: "Paraguay" },
  { code: "BO", flag: "🇧🇴", name_en: "Bolivia", name_es: "Bolivia" },
  { code: "GT", flag: "🇬🇹", name_en: "Guatemala", name_es: "Guatemala" },
  { code: "HN", flag: "🇭🇳", name_en: "Honduras", name_es: "Honduras" },
  { code: "SV", flag: "🇸🇻", name_en: "El Salvador", name_es: "El Salvador" },
  { code: "NI", flag: "🇳🇮", name_en: "Nicaragua", name_es: "Nicaragua" },
  { code: "PA", flag: "🇵🇦", name_en: "Panama", name_es: "Panamá" },
  { code: "BR", flag: "🇧🇷", name_en: "Brazil", name_es: "Brasil" },
  { code: "CA", flag: "🇨🇦", name_en: "Canada", name_es: "Canadá" },
];

const BY_CODE = Object.fromEntries(COUNTRIES.map((c) => [c.code, c]));

export function getCountry(code) {
  return BY_CODE[code] || null;
}

export function countryName(code, locale = "en") {
  const c = BY_CODE[code];
  if (!c) return code;
  return locale === "es" ? c.name_es : c.name_en;
}

export function countryFlag(code) {
  return BY_CODE[code]?.flag || "🌍";
}
